import qs from 'qs';
import { Env, isH5, Fusion } from 'core';
import countryConfig from './countryConfig';

const Storage = {
  initQuery() {
    const lang = this.getLang();
    const country = this.getCountry();
    const ticket = this.getTicket();
    const locale = this.getLocale();
    const cityid = this.getCityid();
    const bundleId = this.getBundleId();

    if (isH5 && this.getHashPath().includes('headpic')) {
      // 头像检查端外页
      if (!lang || !country || !ticket) {
        const url = this.setQuery({
          lang: this.getQuery('lang') || this.getQuery('l') || 'es-MX',
          location_country: this.getQuery('location_country') || this.getQuery('c') || 'MX',
          ticket: ticket || 'ticket',
        });
        window.location.replace(url);
        window.location.reload();
      }
    } else if (Env.APP_ENV === 'development') {
      // 开发环境初始化链接参数
      if (!lang || !country || !ticket || !locale || !cityid || !bundleId) {
        const url = this.setQuery({
          lang: lang || 'es-MX',
          location_country: country || 'MX',
          ticket: ticket || 'ticket',
          locale: locale || 'es_MX',
          location_cityid: cityid || '0',
          bundle_id: bundleId || 'com.didiglobal.fleet',
        });
        window.location.replace(url);
        window.location.reload();
      }
    }
  },

  // query
  setQuery(newQuery: { [key: string]: string }) {
    const {
      protocol, host, pathname, hash,
    } = window.location;
    const hashPath = hash.split('?')[0];
    const hashSearch = hash.split('?')[1];
    const query = qs.parse(hashSearch, { decoder: (str) => str });
    Object.entries(newQuery).forEach(([key, value]) => {
      query[key] = value;
    });
    const newUrl = `${protocol}//${host}${pathname}${hashPath}?${qs.stringify(query)}`;
    return newUrl;
  },

  setUrlLenCodeQuery(newQuery: { [key: string]: string }) {
    const {
      protocol, host, pathname, hash,
    } = window.location;
    const hashPath = hash.split('?')[0];
    const hashSearch = hash.split('?')[1];
    const query = qs.parse(hashSearch);
    Object.entries(newQuery).forEach(([key, value]) => {
      query[key] = value;
    });
    const newUrl = `${protocol}//${host}${pathname}${hashPath}?${qs.stringify(query)}`;
    return newUrl;
  },

  getAllQuery() {
    const query: any = {
      ...qs.parse(window.location.hash.split('?')[1], { decoder: (str) => str }),
      ...qs.parse(window.location.search.split('?')[1], { decoder: (str) => str }),
    };
    return query;
  },

  getHashPath() {
    return window.location.hash.split('?')[0];
  },

  getUrlLenCodeQuery<T>(key: string) {
    return this.getUrlLenCodeAllQuery()[key] as T;
  },

  getUrlLenCodeAllQuery() {
    const query: any = {
      ...qs.parse(window.location.hash.split('?')[1]),
      ...qs.parse(window.location.search.split('?')[1]),
    };
    return query;
  },

  getQuery<T>(key: string) {
    const querys: any = this.getAllQuery()[key];
    if (querys instanceof Array) {
      // 兼容url参数重复拼接问题
      return querys?.[(querys?.length as number) - 1 || 0] as T;
    }
    return querys as T;
  },

  // 国家
  getCountry() {
    return this.getQuery<string>('location_country');
  },

  // 语言
  getLang() {
    return sessionStorage.lang || this.getQuery<string>('lang');
  },

  // Ticket
  getTicket() {
    return this.getQuery<string>('ticket');
  },

  // locale
  getLocale() {
    return this.getQuery<string>('locale');
  },

  // cityid
  getCityid() {
    return this.getQuery<string>('location_cityid');
  },

  // bundleId
  getBundleId() {
    return this.getQuery<string>('bundle_id') || this.getCountryConfig()?.app_bundle_id;
  },

  getCommonQuery() {
    return {
      lang: this.getLang(),
      location_country: this.getCountry(),
      ticket: this.getTicket(),
      locale: this.getLocale(),
      location_cityid: this.getCityid(),
      bundle_id: this.getBundleId(),
    };
  },

  async getLockdownQuery() {
    const phoneInfo: any = await new Promise((resolve) => {
      if (Fusion?.getSystemInfo) {
        Fusion.getSystemInfo({}, (info: any) => {
          resolve(info);
        });
      } else {
        resolve(null);
      }
    });
    // 封控策略参数
    return {
      user_agent: window.navigator.userAgent,
      lat: this.getQuery('lat') || 0,
      lng: this.getQuery('lng') || 0,
      model: phoneInfo?.model || (/(?:Android)/.test(navigator.userAgent) ? 'android' : 'iPhone'),
    };
  },

  getCountryConfig() {
    return countryConfig[this.getCountry()] || countryConfig.MX;
  },
};

export default Storage;
